// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"6cdb06b4","417":"3604d330","453":"05d4de65","461":"c09b66dc","649":"41521260","833":"4b59cf96"}[chunkId] + ".chunk.js";
};